<ion-card class="post">
  <ion-card-content class="ion-no-padding">
    <img [src]="post.imageUrl" style="width: 100%" (click)="CheckDoubleClick(post.id)" />
    <div class="interact">
      <ion-icon name="heart-outline" *ngIf="!post.isLiked" (click)="ToggleLike(post.id)" class="like"></ion-icon>
      <ion-icon name="heart" color="danger" *ngIf="post.isLiked" class="like" (click)="ToggleLike(post.id)"></ion-icon>
      <ion-text style="margin-right: 16px">{{ post.likesCount }}</ion-text>
      <ion-button fill="clear" (click)="ViewComments(post.id, post.userid)" color="darkmimbo">
        <ion-icon name="chatbubble-outline"></ion-icon>
        <ion-text>{{ post.commentsCount }}</ion-text>
      </ion-button>
      <ion-button class="options" fill="clear" (click)="presentActionSheet(post)">
        <ion-icon name="ellipsis-vertical-outline" slot="icon-only"></ion-icon></ion-button>

      <!-- <ion-text class="date">{{ formatDate(post.createdDate) }}</ion-text> -->
    </div>
    <ion-text>
      <div class="footer">
        <span class="username" (click)="openUserOptions(post.userid, post.username)">{{ "@" + post.username }}</span>
        <span class="caption" [innerHTML]="post.caption"></span>
        <span class="date">{{ formatDate(post.createdDate) }}</span>
      </div>
    </ion-text>
  </ion-card-content>
</ion-card>
<div class="line-break"></div>